import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import type { NavigateFunction } from '../../utils/router/useNavigate';
import postPath, { publicPostPath } from '../../utils/url/postPath';

const GET_POST_PATH_FRAGMENT = gql(`
  fragment getPostPath_post on PublicPostFields {
    ...postPath_post
  }
`);

type GetPostPathPostFragment = DocumentType<typeof GET_POST_PATH_FRAGMENT>;

export const getPostPath = (
  post: GetPostPathPostFragment,
  publicPath?: boolean,
) => {
  return publicPath ? publicPostPath(post) : postPath(post);
};

const REPLACE_POST_PATH_POST_FRAGMENT = gql(`
  fragment replacePostPath_post on PublicPostFields {
    ...getPostPath_post
  }
`);

type ReplacePostPathPostFragment = DocumentType<
  typeof REPLACE_POST_PATH_POST_FRAGMENT
>;

const replacePostPath = (
  post: ReplacePostPathPostFragment | string,
  navigate: NavigateFunction,
  publicPath?: boolean,
) => {
  const path = typeof post === 'string' ? post : getPostPath(post, publicPath);
  if (path !== document.location.pathname) {
    navigate(
      {
        pathname: path,
        search: document.location.search,
        hash: document.location.hash,
      },
      {
        replace: true,
      },
    );
  }
};

export default replacePostPath;
